<template>
  <div class="ride-list__card">
    <!--
      WAITING_DRIVERS_ANSWERS
      CAR_ON_THE_WAY
      WAITING_FOR_PASSENGER
      CAR_ARRIVED
      IN_PROGRESS
      RIDE_ENDED

      CANCELED_BY_DRIVER
      CANCELED_BY_PASSENGER
      COULDNT_FIND_AVAILABLE_DRIVERS
      DRIVERS_REJECTED
    -->
    <Header :status="ride.status" />
    <Body :ride="ride" />
    <Footer :ride="ride" @rideEvent="handleRideEvent" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Header from 'components/newWebCall/drawer/rideList/card/Header'
import Body from 'components/newWebCall/drawer/rideList/card/Body'
import Footer from 'components/newWebCall/drawer/rideList/card/Footer'

export default {
  name: 'Card',
  props: {
    ride: {
      type: Object,
      required: true
    }
  },
  components: {
    Header,
    Body,
    Footer
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.card'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    emitEvent (event) {
      this.$emit('rideEvent', event)
    },

    handleRideEvent ({ event, ride, rideId }) {
      this.emitEvent({ event, ride, rideId })

      if (event === 'discard') {
        return this.discardRide(rideId)
      }

      if (event === 'viewDetails') {
        return this.viewRideDetails({ rideId, ...ride })
      }

      if (event === 'talkToDriver') {
        this.talkToDriver({ rideId, ...ride })
      }
    },

    async discardRide (rideId) {
      try {
        await this.$apiService.removeNotification(rideId)
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.discardRideMessage.success`)
        })
      } catch (error) {
        console.log('ERROR:', error)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.discardRideMessage.success`)
        })
      }
    },

    viewRideDetails (ride) {
      console.log('viewRideDetails', ride)
    },

    talkToDriver (ride) {
      console.log('talkToDriver', ride)
    }
  }
}
</script>

<style lang="scss" scoped>
.ride-list__card {
  position: relative;
  /* TO DO */
}
</style>
